import { useRef, useState } from "react";
import { useIndicatorsQuery } from "./hooks/useIndicatorsQuery";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Table from "../../common/components/Table";
import Textfield from "../../common/components/Textfiled";
import IconButton from "../../common/components/IconButton";
import { DateUtil } from "../../common/utils/date.util";
import { BsFileSpreadsheet } from "react-icons/bs";


const columns = [
  { header: "Indicador", accessor: "description" },
  { header: "Trimestre 1", accessor: "Q1" },
  { header: "Trimestre 2", accessor: "Q2" },
  { header: "Trimestre 3", accessor: "Q3" },
  { header: "Trimestre 4", accessor: "Q4" },
  {
    header: "Total",
    accessor: "description",
    render: (_, item) => item.Q1 + item.Q2 + item.Q3 + item.Q4,
  },
];

function Indicators() {
  const containerTables = useRef(null);
  const [filters, setFilters] = useState({ startDate: DateUtil.getStartOfYear(), endDate:  DateUtil.now() });
  const { indicators, loading } = useIndicatorsQuery(filters);

  const exportToPDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");

    Object.keys(indicators).forEach((year, yearIndex) => {
      if (yearIndex > 0) pdf.addPage();

      pdf.setFontSize(16);
      pdf.text(`Indicadores ${year}`, 14, 20);

      const rows = indicators[year].map((item) => [
        item.description,
        item.Q1,
        item.Q2,
        item.Q3,
        item.Q4,
        item.Q1 + item.Q2 + item.Q3 + item.Q4,
      ]);

      autoTable(pdf, {
        startY: 30,
        head: [
          [
            "Indicador",
            "Trimestre 1",
            "Trimestre 2",
            "Trimestre 3",
            "Trimestre 4",
            "Total",
          ],
        ],
        body: rows,
        styles: {
          fontSize: 11,
          cellPadding: 4,
        },
        headStyles: {
          fillColor: [22, 78, 99], // tailwind slate-800-ish
          textColor: 255,
        },
        margin: { left: 14, right: 14 },
      });
    });

    pdf.save("indicadores.pdf");
  };

  return (
    <main className="container-fluid p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Indicadores</h1>
        <div className="d-flex gap-2">
          <IconButton tooltipText="Exportar a Excel" onClick={() => exportToPDF()}>
            <BsFileSpreadsheet size={24} />
          </IconButton>
        </div>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3 justify-content-center justify-content-md-end">
          <div className="d-flex gap-1 mx-auto">
            <Textfield
              label="Fecha inicio"
              type="date"
              name="startDate"
              value={filters.startDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, startDate: value }))
              }
            />
            <Textfield
              label="Fecha fin"
              type="date"
              name="endDate"
              value={filters.endDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, endDate: value }))
              }
            />
          </div>
        </div>

        <div ref={containerTables}>
          {Object.keys(indicators).map((key) => (
            <div
              key={key}
              className="mb-5 p-4 border rounded shadow-sm bg-light"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <h2 className="h4 text-primary mb-3 border-bottom pb-2">{key}</h2>
              <Table
                columns={columns}
                data={indicators[key]}
                loading={loading}
              />
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Indicators;
